
















import { Component, Vue, Emit } from "vue-property-decorator";
import HeaderDropdown from "./HeaderDropdown.vue";

@Component({
  components: {
    HeaderDropdown
  }
})
export default class Header extends Vue {
  @Emit()
  public sidebarToggle(e: any) {
    e.preventDefault();
    document.body.classList.toggle("sidebar-hidden");
  }

  @Emit()
  public sidebarMinimize(e: any) {
    e.preventDefault();
    document.body.classList.toggle("sidebar-hidden");
  }

  @Emit()
  public mobileSidebarToggle(e: any) {
    e.preventDefault();
    document.body.classList.toggle("sidebar-mobile-show");
  }

  @Emit()
  public asideToggle(e: any) {
    e.preventDefault();
    document.body.classList.toggle("aside-menu-hidden");
  }
}
